module.exports = __webpack_public_path__ + "static/media/0.f49bbef8.png";